module.exports = __webpack_public_path__ + "img/25.f6549ce0.webp";